/**
 * inCust terminal API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface IncustControllersTermApiFuelControllerNozzleTankSetRequest {
  /**
   * Tank ID
   */
  id: string;
  /**
   * Set pump nozzle Grade by Tank Grade
   */
  set_grade_by_tank?: boolean;
}
